import { ILogframeworkServices } from './logframework.types'
import { http } from '@/shared/https'

export class LogframeworkService implements ILogframeworkServices {

    /** method to get the application template */
    getGoals(): any {
        return http.get(`api/Application/Goals`).then((resp: any) => {
            if (resp && resp.data && resp.data.Result === 'OK') {
                return resp.data.Record;
            } else {
                console.log(resp.data.Message);
                return {};
            }
        });
    }
}